var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileButton",
    _vm._g(
      _vm._b(
        { attrs: { "btn-style": "icon", color: "grey.lighten-3" } },
        "MobileButton",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c("svg", {
        directives: [{ name: "svg", rawName: "v-svg" }],
        style: _vm.iconStyle,
        attrs: { symbol: _vm.symbol, size: _vm.iconSize }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileIconButton.vue?vue&type=template&id=2dd61f4d&
// module id = null
// module chunks = 